module.exports = __webpack_public_path__ + "img/12ece4e36758948ca633c4247934ced1.png";